export interface UniversityResponse {
  translationKey: string;
  country: string;
  names: { [language: string]: string };
  description: string;
  testTemplatesForApplications: string[];
  testTemplatesForAutoSend: string[];
}
